<template>
<div>
    <div class="text-info">
        <h1>{{$lang('TITLE_PLEASE_LOGIN_EMAIL_TO_CLICK')}}</h1>
        <h2>
            <router-link @click.native="resentMail" :to="{ name: 'resent_confirm_mail',params: {hash: hash} }">
                {{$lang('TITLE_CLICK_RESEND_EMAIL')}}
            </router-link>
        </h2>
        <h3>{{$lang('TITLE_PLEASE_CHECK_TRASH_EMAIL')}}</h3>
        <h3 v-html="$lang('TITLE_IF_HOTMAIL_ADD_TIP')"></h3>
        <router-link :to="{name: 'home'}" class="login">{{$lang('TEXT_LOGIN')}}</router-link>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            hash: this.$route.params.hash,
            locale: this.$route.params.locale
        }
    },
    methods: {
        resentMail() {
            this.$apis.user.resentConfirmMail({
                hash: this.hash
            }).then(resp => {

            }).catch(err => {
                console.log(err)
            })
        },
        checkHashCode(hash) {
            this.$apis.checkHashCode({
                hash,
            }).then(resp => {

            }).catch(err => {
                this.$router.push({
                    path: '/' + this.locale + '/'
                })
            })
        }
    },
    created() {
        this.checkHashCode(this.hash);
    }
}
</script>
